import React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import styles from './MultiselectMenu.scss.js';
import Checkbox from '../../Inputs/Checkbox/Checkbox.js';
import { sizeOptions } from '../../../../helpers/enums/themes/sizeOptions.js';

const MultiselectMenu = _ref => {
  let {
    isOpen,
    isGrid = false,
    hideInnerBorder = false,
    options,
    onSelect,
    maxHeightValue,
    hideOuterBorder = false,
    selectedValues,
    hasClearButton
  } = _ref;
  const handleSelect = option => {
    if (selectedValues?.some(op => op.type === option.type)) {
      onSelect(selectedValues.filter(item => item.type !== option.type));
    } else {
      onSelect([...selectedValues, option]);
    }
  };
  const buildMenuList = () => options.map(option => /*#__PURE__*/React.createElement("li", {
    className: classNames(styles['options-item'], {
      [styles['options-item--hide-inner-border']]: hideInnerBorder
    }),
    key: option.type
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['options-item-button']
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selectedValues?.some(op => op.type === option.type),
    onChange: () => handleSelect(option),
    size: sizeOptions.small,
    className: styles['options-item-checkbox']
  }), /*#__PURE__*/React.createElement("p", {
    className: styles['options-item-label']
  }, option.content))));
  const optionStyles = {
    maxHeight: maxHeightValue || 'none',
    overflowY: maxHeightValue ? 'auto' : 'visible'
  };
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: isOpen,
    timeout: 250,
    unmountOnExit: true,
    classNames: {
      enter: styles.enter,
      enterActive: styles['enter-active'],
      exit: styles.exit,
      exitActive: styles['exit-active']
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, {
      [styles['wrapper--grid']]: isGrid,
      [styles['wrapper--hide-outer-border']]: hideOuterBorder
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.options,
    style: optionStyles
  }, buildMenuList()), hasClearButton && /*#__PURE__*/React.createElement("li", {
    className: classNames(styles['options-item'], {
      [styles['options-item--hide-inner-border']]: hideInnerBorder
    })
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames(styles['wrapper__clear-button'], {
      [styles['wrapper__clear-button--disabled']]: !selectedValues.length
    }),
    disabled: !selectedValues.length,
    onClick: () => onSelect([])
  }, "Clear All"))));
};
var MultiselectMenu$1 = MultiselectMenu;

export { MultiselectMenu$1 as default };
//# sourceMappingURL=MultiselectMenu.js.map
